import { NsxModule } from '@nirvana/shared/dtos/types/policies/common';

export interface NsxFormValue {
  uiSettings: { nsx: NsxModule };
}

export enum NsxSearchableKeywords {
  Nsx = 'Nsx',
}
